export default __webpack_public_path__ + "static/pic07-4a233463e4f4ff94afb875baa20e84cf.jpg";